import { render, staticRenderFns } from "./ClientHealthScoreIcon.vue?vue&type=template&id=0ae7d562&scoped=true&"
import script from "./ClientHealthScoreIcon.vue?vue&type=script&lang=js&"
export * from "./ClientHealthScoreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae7d562",
  null
  
)

export default component.exports